import styled from "styled-components";
export const MainPageStyle = styled.div`


`;